import type { IpAddress } from "~domain/devices/models/common-device-model.ts";
import type { PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";

import { z } from "zod";

export const backofficeFindPilotLastConnectionResponseSchema = z.object({
  dateUpdate: z.coerce.date().nullable(),
  lastIp: z
    .string()
    .transform((s) => s as IpAddress)
    .nullable(),
  momboxId: z
    .number()
    .transform((s) => s as PilotHwId)
    .nullable(),
  status: z.string(),
});

export type BackofficeFindPilotLastConnectionResponse = z.infer<typeof backofficeFindPilotLastConnectionResponseSchema>;
